export const smsUrl = "https://us-central1-servicesms-df0dc.cloudfunctions.net/api/single"
export const smsAuthorization = "Basic dW5pdHh0Y2xpZW50MTpVSm1FajVIYUFNTHZlbDdpWFRoY1kyd2xXNEptbkpwOQ=="
export const mailerUrl = "https://us-central1-servicescheduler-af9f2.cloudfunctions.net/sendmail"
export const contentType = "application/json"

// **********development stage************
// export const stage = "_dev"
// export const clientUrl = "dev.aftersales.scinnova.com.ph"
// export const branchUrl = "dev.branch.aftersales.scinnova.com.ph"
// export const adminUrl = "dev.admin.aftersales.scinnova.com.ph"
// export const branchMaster = "https://nsjonah-uat.scinnova.com.ph/restlet/branch_master?business_type=RETAIL"
// export const itemMasterNonInventory = "https://nsjonah-uat.scinnova.com.ph/restlet/item/non-inventory?product_type=3&item_class=1"
// export const consumerKey = "7772a3e009bcd9b84128385eb5ba4a1bbb5ad8bbc6bc3bf2d9263a28b7673132"
// export const consumerSecret = "5aba2c641e3d162597267ffd98ae560482611b68e0a3cb8b539bd4d6f9738ef8"
// export const tokenId = "b70ef70c0c2133afe2ea5b1ba1d472073d846931076e0a8c5a41f82c911fc273"
// export const tokenSecret = "e249431e5de59717f10ea06a4a32fdd5cbc4d15da2d809b8a18245460b7c050c"
// export const subAccount = "SC_O_IT"

// **********staging stage*************
// export const stage = "_staging"
// export const clientUrl = "staging.aftersales.scinnova.com.ph"
// export const branchUrl = "staging.branch.aftersales.scinnova.com.ph"
// export const adminUrl = "staging.admin.aftersales.scinnova.com.ph"
// export const branchMaster = "https://nsjonah-uat.scinnova.com.ph/restlet/branch_master?business_type=RETAIL"
// export const itemMasterNonInventory = "https://nsjonah-uat.scinnova.com.ph/restlet/item/non-inventory?product_type=3&item_class=1"
// export const consumerKey = "7772a3e009bcd9b84128385eb5ba4a1bbb5ad8bbc6bc3bf2d9263a28b7673132"
// export const consumerSecret = "5aba2c641e3d162597267ffd98ae560482611b68e0a3cb8b539bd4d6f9738ef8"
// export const tokenId = "b70ef70c0c2133afe2ea5b1ba1d472073d846931076e0a8c5a41f82c911fc273"
// export const tokenSecret = "e249431e5de59717f10ea06a4a32fdd5cbc4d15da2d809b8a18245460b7c050c"
// export const subAccount = "SC_O_Service"

// **********producation stage***********
export const stage = "_prod"
export const clientUrl = "aftersales.scinnova.com.ph"
export const branchUrl = "branch.aftersales.scinnova.com.ph"
export const adminUrl = "admin.aftersales.scinnova.com.ph"
export const branchMaster = "https://nsjonah.scinnova.com.ph/restlet/branch_master?business_type=RETAIL"
export const itemMasterNonInventory = "https://nsjonah.scinnova.com.ph/restlet/item/non-inventory?product_type=3&item_class=1"
export const consumerKey = "67e10df831a44e610aede9423749401363e28bd52d1c5615952b4cbdb4f7b182"
export const consumerSecret = "d7d8fac5228339bddc237e38060722a5ab334a2c8c5c5af6fea49bb54f103829"
export const tokenId = "344d22b848a238144143d6af1db839356a8a9497b99ea61725f6aa6c63c9a45f"
export const tokenSecret = "4a982c7162ad4993e691dc7ae5ecd3fe8d2e189b5f31f92c56c2b14b37522143"
export const subAccount = "SC_O_Service"